import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import contactbg from '../../assets/img/about3.jpg';

class Contactform extends Component {
    render() {
        return (
            <div className="row">
                <div className="col-lg-2 d-none d-lg-block">
                    <div className="section">
                        <div className="section-title flip d-none d-lg-block">
                            <h4 className="title">Get in Touch!</h4>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 position-relative">
                    <div className="section">
                        <div className="container-fluid">
                            <div className="section-title d-block d-lg-none">
                                <h4 className="title">Get in Touch!</h4>
                            </div>
                            <form>
                                <div className="form-group">
                                    <label>Full Name</label>
                                    <input type="text" className="form-control" name="Name" />
                                </div>
                                <div className="form-group">
                                    <label>Email Address <em className="text-danger">*</em> </label>
                                    <input type="email" className="form-control" name="email" />
                                </div>
                                <div className="form-group">
                                    <label>Subject <em className="text-danger">*</em> </label>
                                    <input type="text" className="form-control" name="subject" />
                                </div>
                                <div className="form-group">
                                    <label>Message <em className="text-danger">*</em> </label>
                                    <textarea name="message" cols={45} rows={5} className="form-control" />
                                </div>
                                <button type="submit" className="sigma_btn-custom secondary" name="button">Submit Now</button>
                            </form>
                        </div>
                    </div>
                </div>
                <div className="offset-lg-1 col-lg-6 position-relative">
                    <div className="bg-cover sigma_contact-bg mt-0"  >
                    <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d465.1208091232695!2d79.1137809!3d21.1537325!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bd4c733eb30e9b3%3A0xd50e1d5f8daa0007!2zMjHCsDA5JzEzLjciTiA3OcKwMDYnNTAuMyJF!5e0!3m2!1sen!2sin!4v1645253338957!5m2!1sen!2sin" width="450" height="450" style={{border: "0"}} allowfullscreen="" loading="lazy"></iframe>
                    </div>
                    <div className="sigma_contact-info">
                        <h3 className="text-white">Contact Details</h3>
                        <div className="sigma_contact-info-item">
                            <h6>Location</h6>
                            <p>Kamla Heights, Paithankar Road, Itwari</p>
                            <p>, Nagpur- 02, M.H. India </p>
                        </div>
                        <div className="sigma_contact-info-item">
                            <h6>Mail Box</h6>
                            <p>gemsgnine@gmail.com</p>
                            
                        </div>
                        <div className="sigma_contact-info-item">
                            <h6>Call At</h6>
                            <p>(+91) 8928330046</p>
                        </div>
                        <div className="sigma_contact-info-item">
                            <ul className="sigma_sm">
                                <li> <Link to="/"> <i className="fab fa-facebook-f" /> </Link> </li>
                                <li> <Link to="/"> <i className="fab fa-instagram" /> </Link> </li>
                                <li> <Link to="/"> <i className="fab fa-twitter" /> </Link> </li>
                                <li> <Link to="/"> <i className="fab fa-linkedin-in" /> </Link> </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Contactform;